import { BarChart3, FolderTree, Lock, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'

/**
 * 실제로 제공하는 기능만 싣는다.
 * 커스텀 도메인·화이트라벨·웹훅은 구현이 없어 넣지 않는다.
 */
const FEATURES = [
  { key: 'featureAnalytics', Icon: BarChart3 },
  { key: 'featureOrganize', Icon: FolderTree },
  { key: 'featureSecurity', Icon: Lock },
  { key: 'featureTeam', Icon: Users },
] as const

export default function FeatureGrid() {
  const { t } = useTranslation()

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {FEATURES.map(({ key, Icon }) => (
        <article
          key={key}
          className="flex flex-col gap-3 rounded-2xl border border-gray-200 bg-white p-6 transition hover:border-primary-200 hover:shadow-[0_12px_32px_-16px_rgba(37,99,235,0.3)] dark:border-gray-700 dark:bg-gray-800 dark:hover:border-primary-800"
        >
          <span className="mb-2 grid h-11 w-11 place-items-center rounded-xl bg-primary-50 text-primary-600 dark:bg-primary-950/60 dark:text-primary-400">
            <Icon className="h-[22px] w-[22px]" />
          </span>
          <h3 className="text-lg font-bold tracking-tight text-gray-900 dark:text-white">
            {t(`home.${key}Name`)}
          </h3>
          <p className="text-[15px] leading-relaxed text-gray-600 dark:text-gray-400">
            {t(`home.${key}Desc`)}
          </p>
        </article>
      ))}
    </div>
  )
}
